/*
 ######## ######## ##     ## ########         ######## ##     ##
    ##    ##         ## ##      ##            ##         ## ##
    ##    ######      ###       ##    ####### ######      ###
    ##    ##         ## ##      ##            ##         ## ##
    ##    ######## ##     ##    ##            ######## ##     ##
クリックでテキストを開閉

<div class="js-textExpand--hoge activeToggle">


    <button type="button" class="js-textExpand expandItem__more flex vcenter hcenter" data-target="hoge" data-border-pc="150" data-border-sp="150">
        <div class="is-false activeToggle__off">もっと見る</div>
        <div class="is-false activeToggle__on">閉じる</div>
        <i class="is-false movieText__icon icon-down"></i>
    </button>
</div>
*/
window.textExpand = function () {
  const textExpand = document.querySelectorAll('.js-textExpand:not(.setup)')
  if (textExpand[0]) {
    // 高さをチェックし、想定より低い場合は開閉機構を省略する
    for (const expandBtn of textExpand) {
      const target = expandBtn.dataset.target
      expandBtn.classList.add('setup')
      // 表示デバイスに対する基準の高さを取得
      let border = 0
      if (window.matchMedia('(min-width:769px)').matches) {
        border = expandBtn.dataset.borderPc
      } else {
        border = expandBtn.dataset.borderSp
      }

      const expandTarget = document.getElementsByClassName('js-textExpand--' + target)
      for (const iterator of expandTarget) {
        if (iterator.offsetHeight < border) {
          iterator.classList.add('active')
          iterator.classList.add('full')
          expandBtn.style.display = 'none'
        }
      }
    }
  }
}
window.textExpand() // クリックでテキストを開閉

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-textExpand')) {
    return
  }
  const target = e.target.dataset.target

  const expandTarget = document.getElementsByClassName('js-textExpand--' + target)

  for (const iterator of expandTarget) {
    iterator.classList.toggle('active')
  }
})
